
    <fieldmagic-dialog
      label="Job Report"
      icon="file-pdf"
      [instance]="this"
    >
      <ng-template fieldmagicDialogButtonsTmp>
        <fieldmagic-primary-button
          icon="file-pdf"
          label="Preview"
          (click)="onPreview()"
          [disabled]="fetching$ | async"
        >
        </fieldmagic-primary-button>
      </ng-template>

      <ng-template fieldmagicDialogContentTmp>
        <div class="d-flex d-flex-gap flex-column">
          <ng-container *ngIf="fetching$ | async">
            <div class="w-100 d-flex justify-content-center">
              <fieldmagic-icon [spin]="true"></fieldmagic-icon>
            </div>
          </ng-container>

          <ng-container *ngIf="!(fetching$ | async)">
              <ng-container *ngIf="paginated$ | async as types">
                <fieldmagic-pagination-links
                  *ngIf="types | filled"
                  [hideRefresh]="true"
                  [topOnly]="true"
                >
                  <table
                    class="table table-bordered"
                  >
                    <thead>
                      <tr>
                        <td width="98%">
                          <fieldmagic-text
                            purpose="table-header"
                            content="Asset Types"
                          >
                          </fieldmagic-text>
                        </td>

                        <td width="2%">
                          <fieldmagic-checkbox-input
                            [useNative]="true"
                            [(ngModel)]="all"
                            tooltip="Click to select/unselect all"
                            (ngModelChange)="onSelectAll($event)"
                          ></fieldmagic-checkbox-input>
                        </td>
                      </tr>
                    </thead>

                    <tbody>
                      <ng-container *ngIf="! (fetching$ | async)">
                        <ng-container *ngIf="paginated$ | async as types">
                          <tr
                            *ngIf="types | blank"
                            class="text-center"
                          >
                            <td colspan="2">{{ 'No available asset types' | translate }}</td>
                          </tr>

                          <ng-container *ngIf="types | filled">
                            <tr *ngFor="let type of types; let type_index = index">
                              <td>{{ type.name }}</td>
                              <td>
                                <fieldmagic-checkbox-input
                                  [useNative]="true"
                                  [(ngModel)]="type.selected"
                                  (ngModelChange)="onAssetSelect(type_index, $event)"
                                  tooltip="Click to select/unselect"
                                >
                                </fieldmagic-checkbox-input>
                              </td>
                            </tr>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </tbody>
                  </table>
                </fieldmagic-pagination-links>
              </ng-container>

            <table class="table table-bordered">
              <thead>
                <tr>
                  <td width="98%">
                    <fieldmagic-text
                      content="What would you like to include?"
                      purpose="table-header"
                    >
                    </fieldmagic-text>
                  </td>
                  <td width="2%">
                    <fieldmagic-checkbox-input
                      [(ngModel)]="include"
                      [useNative]="true"
                      tooltip="Click to select/unselect all"
                      (ngModelChange)="onIncludingAll($event)"
                    >
                    </fieldmagic-checkbox-input>
                  </td>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>{{ 'Work Order' | translate }}</td>
                  <td>
                    <fieldmagic-checkbox-input
                      [(ngModel)]="showWorkOrder"
                      [useNative]="true"
                      tooltip="Click to select/unselect"
                      (ngModelChange)="onInclusionToggle()"
                    >
                    </fieldmagic-checkbox-input>
                  </td>
                </tr>

                <tr>
                  <td>{{ 'Time Entries' | translate }}</td>
                  <td>
                    <fieldmagic-checkbox-input
                      [(ngModel)]="showTimeEntries"
                      [useNative]="true"
                      tooltip="Click to select/unselect"
                      (ngModelChange)="onInclusionToggle()"
                    >
                    </fieldmagic-checkbox-input>
                  </td>
                </tr>

                <tr>
                  <td>{{ 'Materials' | translate }}</td>
                  <td>
                    <fieldmagic-checkbox-input
                      [(ngModel)]="showMaterials"
                      [useNative]="true"
                      tooltip="Click to select/unselect"
                      (ngModelChange)="onInclusionToggle()"
                    >
                    </fieldmagic-checkbox-input>
                  </td>
                </tr>

                <tr>
                  <td>{{ 'Notes' | translate }}</td>
                  <td>
                    <fieldmagic-checkbox-input
                      [(ngModel)]="showWorkNotes"
                      [useNative]="true"
                      tooltip="Click to select/unselect"
                      (ngModelChange)="onInclusionToggle()"
                    >
                    </fieldmagic-checkbox-input>
                  </td>
                </tr>

                <tr>
                  <td>{{ 'Completed Tasks' | translate }}</td>
                  <td>
                    <fieldmagic-checkbox-input
                      [(ngModel)]="showTasks"
                      [useNative]="true"
                      tooltip="Click to select/unselect"
                      (ngModelChange)="onInclusionToggle()"
                    >
                    </fieldmagic-checkbox-input>
                  </td>
                </tr>

                <tr>
                  <td>{{ 'Photos' | translate }}</td>
                  <td>
                    <fieldmagic-checkbox-input
                      [(ngModel)]="showPhotos"
                      [useNative]="true"
                      tooltip="Click to select/unselect"
                      (ngModelChange)="onInclusionToggle()"
                    >
                    </fieldmagic-checkbox-input>
                  </td>
                </tr>

                <tr>
                  <td>{{ 'Job Checklists' | translate }}</td>
                  <td>
                    <fieldmagic-checkbox-input
                      [(ngModel)]="includeJobChecklists"
                      [useNative]="true"
                      tooltip="Click to select/unselect"
                      (ngModelChange)="onInclusionToggle()"
                    >
                    </fieldmagic-checkbox-input>
                  </td>
                </tr>

                <ng-container *ngIf="types$ | async as types">
                  <tr *ngIf="types | filled">
                    <td>{{ 'Failed Assets Only' | translate }}</td>
                    <td>
                      <fieldmagic-checkbox-input
                        [(ngModel)]="failAssetsOnly"
                        [useNative]="true"
                        tooltip="Click to select/unselect"
                        (ngModelChange)="onInclusionToggle()"
                      >
                      </fieldmagic-checkbox-input>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </ng-container>
        </div>
      </ng-template>
    </fieldmagic-dialog>
  